import { apiSlice } from "./apiSlice";

export const operatingCostSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllOperatingCost: builder.query({
            query: (params) => ({
                url: `OperatingCost`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["CAMTracker"],
        }),

        createOperatingCost: builder.mutation({
            query: ({ body }) => ({
                url: `OperatingCost`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["CAMTracker"],
        }),

        updateOperatingCost: builder.mutation({
            query: ({ body }) => ({
                url: `OperatingCost`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["CAMTracker"],
        }),
        getExportOperatingCost: builder.query({
            query: (params) => ({
                url: `Insurance`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const { useLazyGetAllOperatingCostQuery, useCreateOperatingCostMutation, useUpdateOperatingCostMutation, useLazyGetExportOperatingCostQuery } = operatingCostSlice;